import { omit } from "lodash"
import { SocialPost } from "types/campaign/collaborations"
import { SocialAccount } from "types/influencer"

export interface InsightItem {
    [key: string]: any
}

export interface TiersInsightItem {
    [key: string]: InsightItem
}

export interface DateWiseInsight {
    date: string,
    values: InsightItem
}

export interface DateWiseTiersInsight {
    date: string,
    values: TiersInsightItem
}

export interface CompetitionGroupAccount {
    via: 'self' | 'competition',
    social_account: SocialAccount,
    total_insight: InsightItem,
    creator_follower_tier_insight: {
        [key: string]: InsightItem
    },
    period_creator_follower_tier_insights: DateWiseTiersInsight[],
    period_total_insights: DateWiseInsight[],
    share_of_voice: Record<string, number>
    // [key: string]: any
}

export interface CompetitionGroup {
    uuid: string,
    name: string,
    accounts: CompetitionGroupAccount[]
}

export interface CompetitionGroupShort extends Omit<CompetitionGroup, 'accounts'> { }

export interface CreatorFollowerTier {
    name: string,
    slug: string,
    minimum: number,
    maximum: number
}

export interface Competitor {
    via: 'self' | 'competition',
    social_account: SocialAccount
}

export interface CompetitionContentFilters {
    page: number,
    [key: string]: any
}

export interface CompetitionPost {
    social_post: SocialPost
}

export interface CompetitionAnalysisState {
    groups: {
        loading: boolean,
        error: string | null,
        items: CompetitionGroup[],
        count: number,
        last_fetched_at: number,
    },
    loading: boolean,
    error: string | null,
    group: Record<string, // groupId
        {
            data: CompetitionGroup,
            creator_follower_tiers: CreatorFollowerTier[],
            last_fetched_at: number,
        }
    >,
    shared_group: Record<string, // groupShareId
        {
            data: CompetitionGroup,
            creator_follower_tiers: CreatorFollowerTier[],
            last_fetched_at: number,
        }
    >,
    shares: {
        loading: boolean,
        data: Record<string, //groupId
            {
                uuid: string,
                last_fetched_at: number
            }
        >,
        error: string | null
    }
    competitors: {
        loading: boolean,
        error: string | null,
        items: Competitor[],
        count: number,
        last_fetched_at: number,
    },
    content: {
        applied_filter_id: string | null,
        loading: boolean,
        error: string | null,
        filters: CompetitionContentFilters,
        total: number,
        filtered_lists: Record<string, //FilterId
            {
                items: CompetitionPost[],
                last_fetched_at: number,
                error: string | null,
                loading: boolean,
                count: number,
                has_more: boolean,
                page: number,
                filters: CompetitionContentFilters,
                expired: boolean
            }>
    },
}

export const formattableInsightItem = ['engagements', 'views', 'creators', 'posts'];

export const insightItemsLabel = {
    posts: 'Posts',
    engagement_score: 'Engagement Score',
    creators: 'Creators',
    engagements: 'Engagements',
    views: 'Views',
}

export const defaultCompetitionContentFilters = {
    page: 1
}